import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { eiwrsDepotManagementServices } from "../../../../APIServices/EIWRS/eiwrsDepotManagementServices";

const UpdateDepot = ({
  rowData,
  depotColumns,
  getStudyDepotRowData,
  Show,
  Hide,
  Title,
  setRowId,
  countryList
}) => {
  const [depotRow, setDepotRow] = useState({});
  const handleDepotRowChange = (e, columnKey) => {
    setDepotRow({
      ...depotRow,
      [columnKey]: e.target.value,
    });
  };
  let { studyId } = useParams();
  const [buttonLoader, setButtonLoader] = useState(false);

  const updateStudyDepotRowData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Depot!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = rowData?._id;
        userData.studyId = studyId;
        userData.depotRow = depotRow;
        let data =
          await eiwrsDepotManagementServices.updateStudyDepotRowData(
            userData
          );
        if (data?.statusCode === 200) {
          getStudyDepotRowData();
          setRowId("");
          Hide();
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setDepotRow(rowData?.row);
  }, [rowData]);

  function isRowDataComplete() {
    return depotColumns.every((col) => {
      const key = col.columnName;
      return (
        depotRow?.hasOwnProperty(key) &&
        depotRow?.[key] !== "" &&
        depotRow?.[key] !== null &&
        depotRow?.[key] !== undefined
      );
    });
  }
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {depotColumns?.map((item, index) => (
            <Form.Group key={index} className="mb-1">
              <Form.Label className="fw-bold mb-1">
                {item?.columnLabel}{" "}
                {item?.required === "yes" &&
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                }
              </Form.Label>
              {item?.columnType === "dropdown" ? (
                <>
                  {item?.customOption === "yes" ?
                    <>
                      {item?.columnName === "COUNTRY" &&
                        <Form.Select
                          value={depotRow?.[item?.columnName]}
                          onChange={(e) => handleDepotRowChange(e, item?.columnName)}
                          className="br3" style={{ fontSize: 12 }}>
                          <option value="">Select Country</option>
                          {countryList?.map((el, i) => (
                            <option index={i} value={el?.name} title={el.id}>{el?.name}</option>
                          ))}
                        </Form.Select>
                      }
                    </>
                    :
                    <Form.Select
                      onChange={(e) => handleDepotRowChange(e, item?.columnName)}
                      className="br3"
                      style={{ fontSize: 12 }}
                    >
                      <option value="">Select Option</option>
                      {(item?.columnOption || [])?.map((el, i) => (
                        <option
                          index={i}
                          selected={depotRow?.[item?.columnName] === el?.option}
                          value={el?.option}
                        >
                          {el?.option}
                        </option>
                      ))}
                    </Form.Select>
                  }
                </>
              ) : item?.columnType === "radio" ? (
                (item?.columnOption || [])?.map((el, i) => (
                  <Form.Check
                    key={i}
                    type="radio"
                    label={el?.option}
                    name={item?.columnName}
                    value={el?.option}
                    checked={depotRow?.[item?.columnName] === el?.option}
                    onChange={(e) =>
                      handleDepotRowChange(e, item?.columnName)
                    }
                    className="br3"
                  />
                ))
              ) : (
                item?.columnType === "textarea" ?
                  <Form.Control
                    onChange={(e) => handleDepotRowChange(e, item?.columnName)}
                    value={depotRow?.[item?.columnName] || ""}
                    className="br3"
                    placeholder={`Enter ${item?.columnLabel}`}
                    as={item?.columnType}
                  />
                  :
                  <Form.Control
                    onChange={(e) => handleDepotRowChange(e, item?.columnName)}
                    value={depotRow?.[item?.columnName] || ""}
                    className="br3"
                    placeholder={`Enter ${item?.columnLabel}`}
                    type={item?.columnType}
                  />
              )}
            </Form.Group>
          ))}
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!isRowDataComplete() || buttonLoader}
            onClick={updateStudyDepotRowData}
            className={`updateProfile`}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update depot"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateDepot;
